/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { CreateReservedMarkTransferRequestBodyDto } from '../../models/create-reserved-mark-transfer-request-body-dto';
import { ReservedMarkTransferRequestResultDto } from '../../models/reserved-mark-transfer-request-result-dto';

export interface CreateReservedMarkTransferRequestForUser$Params {
  body: CreateReservedMarkTransferRequestBodyDto;
}

export function createReservedMarkTransferRequestForUser(
  http: HttpClient,
  rootUrl: string,
  params: CreateReservedMarkTransferRequestForUser$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ReservedMarkTransferRequestResultDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    createReservedMarkTransferRequestForUser.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReservedMarkTransferRequestResultDto>;
      }),
    );
}

createReservedMarkTransferRequestForUser.PATH =
  '/me/surveyMarks/reserved/transfer-request';
